import $axios from "@/store/axios-instance";
import store from "@/store/index";

const signalR = require("@microsoft/signalr");

export default {
    state: {
        hubConnection: null,
        currentGroup: null
    },
    mutations: {
        initHub(state, hub) {
            state.hubConnection = hub
        },
        destroyHub(state) {
            state.hubConnection = null
        },
        addToGroup(state, activityId) {
            state.currentGroup = activityId
        },
        leaveGroup(state) {
            state.currentGroup = null
        }
    },
    actions: {
        initHub(context) {
            return new Promise((resolve) => {
                let hubConnection = new signalR.HubConnectionBuilder()
                    .withUrl(process.env.VUE_APP_SIGNALR_PATH, {
                        accessTokenFactory: () => context.getters.token
                    })
                    .configureLogging(signalR.LogLevel.Information)
                    .withAutomaticReconnect()
                    .build()

                // hubConnection.serverTimeoutInMilliseconds = 3600000 //1 hour
                hubConnection.onreconnected(function(){
                    console.info('HUB initEvents onreconnected')
                    context.dispatch('initEvents', {hubConnection: hubConnection})
                })
                hubConnection.start().then(() => {
                    context.dispatch('initEvents', {hubConnection: hubConnection})
                    resolve()
                })
            })
        },
        initEvents(context, payload){
            console.info('HUB initEvents')
            let hubConnection = payload.hubConnection
            hubConnection.on("ReceiveComment", (comment) => {
                context.dispatch('receiveChatComment', {chatId: comment.activityId, comment: comment})
            })

            hubConnection.on("ReceiveActivitiesUnreadCommentsNotification", (data) => {
                context.dispatch('receiveUnreadCommentsNotification', data)
            })

            hubConnection.on("Send", (message) => {
                console.log(message)
            })

            if (context.getters.hasRole(['ClientManager'])) {
                hubConnection.on("ReceiveServiceChangedMessage", (data) => {
                    context.dispatch('receiveServiceChangedMessage', data)
                })
            }
            if (context.getters.hasRole(['Executor'])) {
                hubConnection.on("ReceiveExecutorServiceChangedMessage", (data) => {
                    context.dispatch('receiveServiceChangedMessage', data)
                })
            }
            hubConnection.on("ReceiveServiceRemovedMessage", (data) => {
                context.dispatch('receiveServiceRemovedMessage', data)
            })

            context.commit("initHub", hubConnection)
            let currentGroup = context.state.currentGroup
            if(currentGroup){
                context.dispatch('addToGroup', currentGroup)
            }
        },
        destroyHub(context) {
            context.dispatch('leaveGroup').then(() => {
                let hub = context.getters.hubConnection
                if (hub) {
                    hub.stop().then(() => {
                        context.commit("destroyHub")
                    })
                }
            })
        },
        reInitHub(context){
            let currentGroup = context.state.currentGroup
            context.dispatch('destroyHub').then(() => {
                context.dispatch('initHub').then(() => {
                    if(currentGroup){
                        context.dispatch('addToGroup', currentGroup)
                    }
                })
            })
        },
        checkHub(context) {
            return new Promise((resolve) => {
                let hub = context.getters.hubConnection
                if (hub) {
                    if (hub.state === 'Connected') {
                        resolve()
                    } else {
                        context.dispatch('destroyHub').then(() => {
                            context.dispatch('initHub').then(() => {
                                resolve()
                            })
                        })
                    }
                } else {
                    context.dispatch('initHub').then(() => {
                        resolve()
                    })
                }
            })
        },
        addToGroup(context, activityId) {
            return new Promise((resolve, reject) => {
                try {
                    context.dispatch('checkHub').then(() => {
                        let hub = context.getters.hubConnection

                        console.log(hub.state)
                        hub.invoke("AddToGroup", activityId).then(() => {
                            console.log("Attempting to join group")
                            context.commit("addToGroup", activityId)
                            resolve()
                        })
                    })
                } catch (error) {
                    console.log("Error establishing connection: ", error)
                    reject(error)
                }
            })
        },
        leaveGroup(context) {
            return new Promise((resolve, reject) => {
                context.dispatch('checkHub').then(() => {
                    let hub = context.getters.hubConnection
                    let currentGroup = context.getters.currentGroup

                    if (!currentGroup) {
                        resolve()
                        return
                    }

                    console.log("Try connection stop " + currentGroup)

                    hub.invoke("RemoveFromGroup", currentGroup)
                        .then(() => {
                            context.commit('leaveGroup')
                            console.log("leaveGroup")
                            resolve()
                        })
                        .catch((err) => {
                            console.log(err)
                            reject(err)
                        });
                })
            })
        },
        sendMessage(context, message) {
            return new Promise((resolve, reject) => {
                store.dispatch('setLoading', true)
                let values = {
                    body: message.text,
                    mentionedPhones: message.mentionedPhones,
                    activityId: context.getters.currentGroup,
                    quotedCommentId: message.quotedCommentId
                }
                try {
                    context.dispatch('checkHub').then(() => {
                        let hub = context.getters.hubConnection
                        hub.invoke("SendComment", values).then(() => {
                            store.dispatch('setLoading', false)
                            resolve(context)
                        })
                    })
                } catch (error) {
                    store.dispatch('setLoading', false)
                    console.log(error)
                    reject(error)
                }
            })
        },
        forwardMessage(context, payload) {
            return new Promise((resolve, reject) => {
                try {
                    payload.forwardToChatList.forEach(forwardToChat => {
                        let value = {
                            activityId: forwardToChat,
                            messageIds: payload.messageForwardList
                        }

                        context.dispatch('checkHub').then(() => {
                            let hub = context.getters.hubConnection
                            hub.invoke("ForwardComment", value)
                        })
                    })
                    resolve(context)
                } catch (error) {
                    console.log(error)
                    reject(error)
                }
            })
        },
        deleteMessage(context, payload){
            return new Promise((resolve, reject) => {
                try {
                    context.dispatch('checkHub').then(() => {
                        let hub = context.getters.hubConnection
                        hub.invoke("DeleteComment", payload).then(() => {
                            store.dispatch('removeChatComment', {chatId: payload.activityId, comment: payload.messageId})
                            resolve(context)
                        })
                    })

                    resolve(context)
                } catch (error) {
                    console.log(error)
                    reject(error)
                }
            })
        },
        sendDocumentMessage(context, payload) {
            return new Promise((resolve, reject) => {
                try {
                    if (payload.file) {
                        payload.file.forEach(file => {
                            let formData = new FormData()
                            formData.append('file', file)
                            formData.append('chatMessageTypeId', payload.documentType)
                            formData.append('caption', payload.caption)

                            $axios
                                .post(`activities/${context.getters.currentGroup}/comments`, formData)
                                .then(() => {
                                    resolve()
                                })
                                .catch(error => {
                                    console.log(error)
                                    reject(error)
                                })
                        })
                        resolve()
                    }
                } catch (error) {
                    console.log(error)
                    reject(error)
                }
            })
        },
        sendCommentToService(context, payload){
            return new Promise((resolve, reject) => {
                store.dispatch('setLoading', true)
                let values = {
                    ServiceId : payload.serviceId,
                    CommentToWorkIds: payload.commentToWorkIds
                }
                try {
                    context.dispatch('checkHub').then(() => {
                        let hub = context.getters.hubConnection
                        hub.invoke("SendCommentToService", values).then(() => {
                            store.dispatch('setLoading', false)
                            resolve(context)
                        })
                    })
                } catch (error) {
                    store.dispatch('setLoading', false)
                    console.log(error)
                    reject(error)
                }
            })
        }
    },
    getters: {
        hubConnection(state) {
            return state.hubConnection
        },
        currentGroup(state) {
            return state.currentGroup
        }
    }
}